// removed by extract-text-webpack-plugin
module.exports = {"card":"CardShell__card","card-pad":"CardShell__card-pad","cardPad":"CardShell__card-pad","selected":"CardShell__selected","card-no-border-radius":"CardShell__card-no-border-radius","cardNoBorderRadius":"CardShell__card-no-border-radius","willRemoveBgCobalt10":"CardShell__willRemoveBgCobalt10"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CardShell/CardShell.scss
// module id = 1754
// module chunks = 8